import { ShellMessage } from '../../shell'

export interface AreaPlaceholderProps {
  label: string
}

/** Stand-in for a feature area until it is ported in phase 5. */
export function AreaPlaceholder({ label }: AreaPlaceholderProps) {
  return (
    <ShellMessage title={label}>
      <p>This screen is being rebuilt. Until then, use the portal.</p>
    </ShellMessage>
  )
}
